import React from 'react';
import './errormsginput.css'
import pic77 from "../../assets/pic77.png";
const Errormsginput = (props) => {

     if (!props.message) return null;

    return ( 

            <div className="container-input-errror">
      <img src={pic77} alt="" className="error-icon" />
      <p className="error">{props.message}</p>
    </div>
     );
}
 
export default Errormsginput;